import { LANE_CHOOSER_THEME_KEYS, type LaneChooserTheme } from '@/features/laneChooser/types';

import LakeCharacterJump from '@/features/laneChooser/assets/images/lake/character-jump.svg?react';
import LakeSide1 from '@/features/laneChooser/assets/images/lake/ducks.svg';
import LakeSide2 from '@/features/laneChooser/assets/images/lake/frog.svg';
import LakeSide3 from '@/features/laneChooser/assets/images/lake/thatch.svg';
import LakeSide4 from '@/features/laneChooser/assets/images/lake/watergrass.svg';
import LakeCharacterCorrect from '@/features/laneChooser/assets/lottie/lake/character-correct.json';
import LakeCharacterDefault from '@/features/laneChooser/assets/lottie/lake/character-default.json';
import LakeEndScreenFailedDesktop from '@/features/laneChooser/assets/lottie/lake/endscreen-failed-desktop.json';
import LakeEndScreenFailedMobile from '@/features/laneChooser/assets/lottie/lake/endscreen-failed-mobile.json';
import LakeEndScreenFailedTablet from '@/features/laneChooser/assets/lottie/lake/endscreen-failed-tablet.json';
import LakeEndScreenSuccessDesktop from '@/features/laneChooser/assets/lottie/lake/endscreen-success-desktop.json';
import LakeEndScreenSuccessMobile from '@/features/laneChooser/assets/lottie/lake/endscreen-success-mobile.json';
import LakeEndScreenSuccessTablet from '@/features/laneChooser/assets/lottie/lake/endscreen-success-tablet.json';
import LakeLeftBox from '@/features/laneChooser/assets/lottie/lake/left-box.json';
import LakeMapUnfold from '@/features/laneChooser/assets/lottie/lake/map-unfold.json';
import LakeMiddleBox from '@/features/laneChooser/assets/lottie/lake/middle-box.json';
import LakeRightBox from '@/features/laneChooser/assets/lottie/lake/right-box.json';

const lakeTheme: LaneChooserTheme = {
	key: LANE_CHOOSER_THEME_KEYS.LAKE,
	images: {
		sideElements: [LakeSide1, LakeSide2, LakeSide3, LakeSide4],
		character: { jump: LakeCharacterJump },
	},
	animations: {
		answerBoxes: {
			left: LakeLeftBox,
			middle: LakeMiddleBox,
			right: LakeRightBox,
		},
		character: {
			default: LakeCharacterDefault,
			correct: LakeCharacterCorrect,
		},
		endScreen: {
			success: {
				mobile: LakeEndScreenSuccessMobile,
				tabletPortrait: LakeEndScreenSuccessTablet,
				tabletLandscape: LakeEndScreenSuccessDesktop,
				desktop: LakeEndScreenSuccessDesktop,
			},
			failed: {
				mobile: LakeEndScreenFailedMobile,
				tabletPortrait: LakeEndScreenFailedTablet,
				tabletLandscape: LakeEndScreenFailedDesktop,
				desktop: LakeEndScreenFailedDesktop,
			},
		},
		startScreen: {
			mapUnfold: LakeMapUnfold,
		},
	},
};

export default lakeTheme;
